import React from "react";
import { Box, Typography, Divider, IconButton, Tooltip } from "@mui/material";
import { ChatOutlined, ChatRounded } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  iconButton: {
    color: theme.palette.text.primary,
  },
}));

function Header({ pidFile, toggleChatPanelView, handleToggleChatPanelView }) {
  const { classes } = useStyles();
  return (
    <>
      <Box
        px={3}
        py={2}
        height={64}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}>
        <Typography variant="h6">{pidFile.name}</Typography>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          <Tooltip title="Toggle Chat Pane">
            <IconButton
              className={classes.iconButton}
              onClick={handleToggleChatPanelView}>
              {toggleChatPanelView ? <ChatRounded /> : <ChatOutlined />}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Divider />
    </>
  );
}

export default Header;
